import React from "react"
import PropTypes from "prop-types"
import { ChatBubbleOutline, VerifiedOutlined } from "@mui/icons-material"
import { formatWhen, plural } from "./datetime"

/**
 * One question in a Q&A list. The whole row opens the thread; `context`
 * (course / lecture names in the owner's inbox) renders under the title.
 */
export default function QuestionItem({ question, context, onOpen }) {
    return (
        <button
            type="button"
            onClick={() => onOpen(question)}
            className="flex w-full flex-col gap-1.5 rounded-xl border border-slate-200 bg-white p-3 text-left transition hover:border-indigo-300 sm:p-4"
        >
            <span className="line-clamp-2 text-sm font-semibold text-slate-800">
                {question.title}
            </span>
            {context && (
                <span className="truncate text-xs text-indigo-600">{context}</span>
            )}
            {question.body && (
                <span className="line-clamp-2 text-xs text-slate-500 sm:text-sm">
                    {question.body}
                </span>
            )}
            <span className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-400">
                <span>
                    {question.author_name || "Student"}
                    {question.is_mine ? " (you)" : ""} ·{" "}
                    {formatWhen(question.created_at)}
                </span>
                <span className="flex items-center gap-1">
                    <ChatBubbleOutline sx={{ fontSize: 14 }} />
                    {plural(question.answer_count, "answer")}
                </span>
                {question.has_instructor_answer && (
                    <span className="flex items-center gap-1 font-medium text-emerald-600">
                        <VerifiedOutlined sx={{ fontSize: 14 }} />
                        Instructor answered
                    </span>
                )}
            </span>
        </button>
    )
}

QuestionItem.propTypes = {
    question: PropTypes.object.isRequired,
    context: PropTypes.string,
    onOpen: PropTypes.func.isRequired
}
